import React, { FC } from 'react';
import { Dialog, DialogContent, Grid, IconButton, Typography } from '@mui/material';
import CustomerInviteForm from './CustomerInviteForm';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import CloseIcon from '@mui/icons-material/Close';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const CustomerInviteModal: FC<Props> = ({ isOpen, onClose }) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      TransitionComponent={Transition}
      fullWidth
      maxWidth="md"
      PaperProps={{
        style: { borderRadius: 10 },
      }}
      data-testid="customer-invite-modal"
    >
      <DialogContent>
        <Grid container spacing={2}>
          <Typography variant="h3" marginTop={2} marginLeft={2}>
            Customer Invite
          </Typography>
          {onClose && (
            <IconButton
              aria-label="close"
              onClick={onClose}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
              }}
            >
              <CloseIcon />
            </IconButton>
          )}
          <Grid item xs={12}>
            <CustomerInviteForm onClose={onClose} />
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default CustomerInviteModal;
